import { useEffect } from "react";

const SITE_URL = "https://codesolutions.it.com";
const DEFAULT_TITLE = document.title;
const DEFAULT_DESCRIPTION =
  document.querySelector('meta[name="description"]')?.content || "";

// Updates the document title, description and canonical URL for a route.
const usePageMeta = ({ title, description, path = "/" } = {}) => {
  useEffect(() => {
    document.title = title ? `${title} | Code Solutions` : DEFAULT_TITLE;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.content = description || DEFAULT_DESCRIPTION;
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.href = `${SITE_URL}${path === "/" ? "/" : path}`;
    }
  }, [title, description, path]);
};

export default usePageMeta;
